<template>
  <BaseSection
    heading="Kollektivavtalade kompletterande premier"
    :infoStatus="avtal.infoStatus"
    :show-error="!!avtal.error"
  >
    <div class="spinner-wrapper" v-if="avtal.isLoading"><SmallSpinner /></div>
    <avtalat-table
      v-if="!avtal.isLoading"
      :headings="headings"
      :striped="false"
    >
      <avtalat-table-row
        v-for="(premie, index) in avtal.data?.kompletterandePremier"
        :key="index"
      >
        <avtalat-table-cell>{{ premie.namn }}</avtalat-table-cell>
        <avtalat-table-cell>{{ premie.giltigFrom }}</avtalat-table-cell>
        <avtalat-table-cell>{{ premie.giltigTom || "Tillsvidare" }}</avtalat-table-cell>
        <avtalat-table-cell>{{ premie.planNamn }}</avtalat-table-cell>
      </avtalat-table-row>
    </avtalat-table>
  </BaseSection>
</template>

<script setup lang="ts">
import { computed } from "vue";

import SmallSpinner from "@/components/ui/SmallSpinner.vue";
import { BaseSection } from "@/components/sections";

import { useArbetsgivareStore } from "../store";

const arbetsgivareStore = useArbetsgivareStore();
const avtal = computed(() => arbetsgivareStore.avtal);

const headings = [
  {
    content: "Namn",
  },
  {
    content: "Gäller från",
  },
  {
    content: "Gäller till",
  },
  {
    content: "Gäller för pensionsplan",
  },
];
</script>

<style scoped>
.spinner-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
</style>
